// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IsEmpty = (value: any) => boolean;

export const isEmpty: IsEmpty = (value) =>
  [null, undefined, true, false].includes(value) ||
  value.length === 0 ||
  Object.prototype.toString.call(value) === '[object Date]' ||
  typeof value === 'number' ||
  (Object.keys(value).length === 0 && value.constructor === Object);
